export interface MeetingLayout {
  name: string;
  value: string;
  imageUrl: string;
}

export const meetingLayout: MeetingLayout[] = [
  {
    name: "Auto",
    value: "auto",
    imageUrl: "layout1.png"
  },
  {
    name: "Spotlight",
    value: "spotlight",
    imageUrl: "layout2.png"
  },
  {
    name: "Topbar",
    value: "topbar",
    imageUrl: "layout3.png"
  }
];
